import React from 'react';

import { DataLayer } from './DataLayer';
import { GTM } from './GTM';

interface GTMWithDataLayerProps {
  customScript?: string;
  pageEventData?: Record<string, unknown>;
}

export const GTMWithDataLayer = ({ customScript, pageEventData }: GTMWithDataLayerProps) => {
  return (
    <>
      <DataLayer customScript={customScript} pageEventData={JSON.stringify(pageEventData)} />
      <GTM />
    </>
  );
};
